export default {
  api_r_user_module_advancedSearch_getModuleData: {
    path: 'm/advanced-search/get-module-data/',
  },
  api_r_user_module_advancedSearch_getPermissions: {
    path: 'm/advanced-search/get-permissions/',
  },
  api_r_user_module_advancedSearch_search: {
    path: 'm/advanced-search/search/',
  },
};
